import React from 'react';
import './App.css';
import Calendar from './components/Calendar';
import './components/Calendar.css';


function App() {
  return (
    <div className="App">
      <Calendar />
    </div>
  );
}

export default App;
